// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"wap_privacyPolicy__T72x2","privacyPolicyContent":"wap_privacyPolicyContent__RB_tE"};